import {
  getFormattedContentInstreamPositionOptions,
  getFormattedContentOutstreamPositionOptions,
  getFormattedOnScreenPositionOptions
} from './helpers'

import {
  CONTENT_INSTREAM_POSITIONS,
  CONTENT_OUTSTREAM_POSITIONS,
  ON_SCREEN_POSITIONS
} from '../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

export const getInitialValues = targeting => {
  const formattedOnScreenPositionOptions = getFormattedOnScreenPositionOptions(targeting)
  const formattedInstreamPositionOptions = getFormattedContentInstreamPositionOptions(targeting)
  const formattedOutstreamPositionOptions = getFormattedContentOutstreamPositionOptions(targeting)

  return {
    [ON_SCREEN_POSITIONS]: formattedOnScreenPositionOptions,
    [CONTENT_INSTREAM_POSITIONS]: formattedInstreamPositionOptions,
    [CONTENT_OUTSTREAM_POSITIONS]: formattedOutstreamPositionOptions
  }
}
